import { Component } from '@angular/core';
import { MxBaseComponent } from '../../base/mx.base-component';

@Component({
 standalone: false,
  selector: 'mx-toast',
  templateUrl: './mx.toast.component.html',
  styleUrls: ['./mx.toast.component.scss']
})
export class MxToastComponent extends MxBaseComponent {
  async copyDetails(details?: string) {
    if (!details) {
      return;
    }

    await navigator.clipboard.writeText(details);
  }
}



